module.exports = __webpack_public_path__ + "static/img/logoTitle.b257300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoTitle.png
// module id = I68p
// module chunks = 15